import React, { useEffect, useState } from "react";
import axios from "axios";

import { FaBell } from "react-icons/fa";
import Pagination from "Components/Pagination/Pagination";
import TableLoader from "Components/Common/Loader/TableLoader";
import CreateBulkNotificationModal from "./components/CreateBulkNotification";
import { HiPlus } from "react-icons/hi";
// import Pagination from "Components/Pagination/Pagination";
// import TableLoader from "Components/Common/Loader/TableLoader";

const BulkNotificationTable = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [createModal, setCreateModal] = useState(false);

  const rowsPerPage = 10;

  const fetchBulkNotifications = async (page = 1) => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/notification/get-bulk-notifications`,
        {
          params: {
            page,
            limit: rowsPerPage,
          },
        }
      );

      setNotifications(res.data.data || []);
      setTotalPages(res.data.pagination?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching bulk notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBulkNotifications(currentPage);
  }, [currentPage]);

  return (
    <div className="py-5">
      <div className="rounded-2xl bg-white p-5 shadow-sm">
        {/* Header */}
        <div className="mb-4 flex items-center justify-between">
          <h2 className="flex items-center gap-2 text-lg font-semibold">
            <FaBell className="text-[#c51369]" />
            Bulk Notifications
          </h2>
          <button
            onClick={() => setCreateModal(true)}
            className="flex w-full items-center justify-center rounded-full bg-[#c51369] p-3 text-white hover:bg-[#a10f5b] hover:shadow-lg focus:outline-none md:w-auto"
          >
            <HiPlus className="h-5 w-5" />
          </button>
        </div>

        {/* Table */}
        <div className="overflow-x-auto rounded-t-2xl">
          {loading ? (
            <TableLoader columns={5} />
          ) : (
            <table className="w-full rounded-t-2xl text-left text-sm">
              <thead className="text-md bg-[#e0ced7] uppercase tracking-wide text-navy-900">
                <tr className="text-center">
                  <th className="px-6 py-3">Sl No.</th>
                  <th className="px-6 py-3">Title</th>
                  <th className="px-6 py-3">Message</th>
                  <th className="px-6 py-3">Type</th>
                  <th className="px-6 py-3">Created At</th>
                </tr>
              </thead>

              <tbody>
                {notifications.length === 0 ? (
                  <tr>
                    <td
                      colSpan={5}
                      className="px-6 py-6 text-center text-gray-500"
                    >
                      No notifications found
                    </td>
                  </tr>
                ) : (
                  notifications.map((item, index) => (
                    <tr
                      key={item._id}
                      className="bg-white text-center text-gray-700 transition hover:bg-pink-50"
                    >
                      <td className="border px-6 py-4">
                        {(currentPage - 1) * rowsPerPage + index + 1}
                      </td>

                      <td className="border px-6 py-4 font-medium">
                        {item.title}
                      </td>

                      <td className="max-w-md truncate border px-6 py-4">
                        {item.message}
                      </td>

                      <td className="border px-6 py-4">
                        <span className="rounded-full bg-pink-100 px-3 py-1 text-xs font-semibold text-pink-700">
                          {item.notificationType}
                        </span>
                      </td>

                      <td className="border px-6 py-4 text-sm text-gray-600">
                        {new Date(item.createdAt).toLocaleString()}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          )}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="mt-4 flex justify-end">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </div>
        )}

        <CreateBulkNotificationModal
          open={createModal}
          onClose={() => setCreateModal(false)}
          onSuccess={fetchBulkNotifications}
        />
      </div>
    </div>
  );
};

export default BulkNotificationTable;
